/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/

import { faTasks, IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { TaskDataArray, TaskDataObject } from '../../../models/task.model';
import {
  LocationModel,
  RecordBaseModel,
  WorkflowItemSubtype,
  WorkflowItemType
} from '../record-base.model';

export class ChecklistRecord extends RecordBaseModel {
  itemIcon: IconDefinition = faTasks;
  itemData?: ChecklistRecordData;

  constructor(itemName: string, geolocation?: LocationModel, timestamp?: string) {
    super(itemName, WorkflowItemType.FORM, WorkflowItemSubtype.CHECKLIST, geolocation, timestamp);
  }

  fromJson(json: any): ChecklistRecord | undefined {
    if (!json) return;
    let record = new ChecklistRecord(
      json.itemName.value,
      LocationModel.fromJson(json.geolocation),
      json.timestamp?.value
    );
    let checklistRecordData = Object.create(ChecklistRecordData.prototype);
    record.itemData = checklistRecordData.fromJson(json);

    return record;
  }
}

export class ChecklistRecordData {
  displayedText: string;
  options?: ChecklistItemRecord[];

  constructor(displayedText: string, options: ChecklistItemRecord[] = []) {
    this.displayedText = displayedText;
    this.options = options;
  }

  fromJson(json: any): ChecklistRecordData {
    let displayedText = '';
    let options: ChecklistItemRecord[] = [];
    if (json.formData.type === 'ARRAY') {
      let taskDataArrayModel = Object.create(TaskDataArray.prototype);
      let taskDataArray = taskDataArrayModel.fromJson(json.formData) as TaskDataArray;
      let checklistItemRecord = Object.create(ChecklistItemRecord.prototype);
      for (const item of taskDataArray.value) {
        if (item instanceof TaskDataObject) {
          if (item.value.get('type')?.value === 'TEXT') {
            displayedText = item.value.get('text')?.value;
          }
          if (item.value.get('type')?.value === 'CHECKBOX') {
            options.push(
              new ChecklistItemRecord(
                item.value.get('text')?.value ?? '',
                item.value.get('value')?.value ?? false
              )
            );
          }
        }
      }
    }

    return new ChecklistRecordData(displayedText, options);
  }
}

export class ChecklistItemRecord {
  optionText: string;
  isSelected: boolean;

  constructor(optionText: string, isSelected: boolean) {
    this.optionText = optionText;
    this.isSelected = isSelected;
  }
}
